// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { isDarkMode } from '../../provider/types';
import { blue } from '../primitiveColors/blue';
import { common } from '../primitiveColors/common';
import { green } from '../primitiveColors/green';
import { grey } from '../primitiveColors/grey';
import { mutedBlue, mutedRed, mutedYellow } from '../primitiveColors/muted';
import { red } from '../primitiveColors/red';
import { yellow } from '../primitiveColors/yellow';
var light = {
    default: grey[300],
    soft: grey[200],
    heavy: grey[400],
    active: grey[500],
    heaviest: common.black,
    actionBold: blue[500],
    action100: blue[300],
    action200: blue[400],
    status: {
        error50: red[200],
        error100: red[300],
        error200: red[800],
        error300: red[900],
        warning50: yellow[300],
        warning100: yellow[500],
        warning200: yellow[600],
        warning300: yellow[700],
        success50: green[100],
        success100: green[200],
        success200: green[500],
        success300: green[600],
        info50: blue[100],
        info100: blue[400],
        info200: blue[600],
        info300: blue[900],
        neutral50: grey[100],
        neutral100: grey[300],
        neutral200: grey[500],
        neutral300: grey[800]
    }
};
var dark = {
    default: grey[750],
    soft: grey[800],
    heavy: grey[600],
    active: grey[300],
    heaviest: common.white,
    actionBold: blue[500],
    action100: blue[700],
    action200: blue[600],
    status: {
        error50: mutedRed[900],
        error100: mutedRed[700],
        error200: mutedRed[400],
        error300: mutedRed[300],
        warning50: mutedYellow[800],
        warning100: mutedYellow[600],
        warning200: mutedYellow[500],
        warning300: mutedYellow[400],
        success50: green[900],
        success100: green[700],
        success200: green[400],
        success300: green[300],
        info50: mutedBlue[800],
        info100: mutedBlue[600],
        info200: mutedBlue[400],
        info300: mutedBlue[300],
        neutral50: grey[800],
        neutral100: grey[500],
        neutral200: grey[300],
        neutral300: grey[100]
    }
};
export var line = function(mode) {
    return isDarkMode(mode) ? dark : light;
};

//# sourceMappingURL=line.js.map